export default function SectionLabel({ children, className = "" }) {
  return (
    <span className={`text-[14px] font-medium text-coral ${className}`}>
      {children}
    </span>
  );
}
